document.addEventListener('DOMContentLoaded', function () {
  var DISCOUNT_FACTOR = 0.5; // Aligné sur le thème Warehouse
  var SELECTORS = [
    'sale-price',
    'compare-at-price',
    '.price',
    '.product-price',
    '.cart__price',
    '.regular-price',
    '.cart-drawer__totals__row__money',
    '.my-price'
  ];
  var SUB_PRODUCT_ID = 15282292621637;
  var SUB_VARIANT_ID = 55604313489733;
  var CURRENT_PRODUCT_ID = 0;
  var CURRENT_VARIANT_ID = 0;
  var CART_CACHE_WINDOW = 4000;
  var cartDataCache = null;
  var cartDataTimestamp = 0;
  var cartFetchPromise = null;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ' ';
    decimal = decimal || ',';
    precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
    var parts = (Number(number) || 0).toFixed(precision).split('.');
    var head = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? head + decimal + parts[1] : head;
  }

  function formatMoney(cents) {
    var value = parseInt(cents, 10);
    if (isNaN(value)) value = 0;
    var format =
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && Shopify.money_format) ||
      '';
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(value, format);
      }
    } catch (_e) {}
    return formatWithDelimiters(value / 100, 2, ' ', ',') + ' €';
  }

  function getSubscriptionFlag() {
    try {
      if (typeof getSessionStorage === 'function') {
        return getSessionStorage('subscription_active');
      }
    } catch (_e) {}
    try {
      return sessionStorage.getItem('subscription_active');
    } catch (_e2) {
      return null;
    }
  }

  function shouldApplyReduction() {
    if (CURRENT_PRODUCT_ID === SUB_PRODUCT_ID && SUB_PRODUCT_ID !== 0) return false;
    if (CURRENT_VARIANT_ID === SUB_VARIANT_ID && SUB_VARIANT_ID !== 0) return false;
    return getSubscriptionFlag() === '1';
  }

  function parsePriceCents(el) {
    var cached = el.getAttribute('data-orig-price-cents');
    if (cached) {
      var cachedValue = parseInt(cached, 10);
      if (!isNaN(cachedValue)) return cachedValue;
    }
    var text = (el.innerText || el.textContent || '').replace(/\s/g, '');
    if (!text) return null;
    var match = text.replace(/[^0-9,\.]/g, '').match(/(\d+[\.,]?\d*)/);
    if (!match) return null;
    var normalized = match[1].replace(',', '.');
    var numeric = parseFloat(normalized);
    if (isNaN(numeric)) return null;
    return Math.round(numeric * 100);
  }

  function storeOriginal(el) {
    if (!el.hasAttribute('data-orig-price-html')) {
      el.setAttribute('data-orig-price-html', el.innerHTML);
    }
    if (!el.hasAttribute('data-orig-price-style')) {
      el.setAttribute('data-orig-price-style', el.getAttribute('style') || '');
    }
  }

  function toggleSubscriptionUpsell() {
    var container = document.querySelector('.cart-drawer__recommendations');
    if (!container) return;
    if (!container.getAttribute('data-upsell-original-display')) {
      container.setAttribute('data-upsell-original-display', container.style.display || '');
    }
    var hasActiveSubscription = getSubscriptionFlag() === '1';
    if (hasActiveSubscription) {
      if (!container.hasAttribute('data-upsell-hidden')) {
        container.setAttribute('data-upsell-hidden', '1');
        container.style.display = 'none';
      }
    } else if (container.hasAttribute('data-upsell-hidden')) {
      container.removeAttribute('data-upsell-hidden');
      var originalDisplay = container.getAttribute('data-upsell-original-display') || '';
      container.style.display = originalDisplay;
    }
  }

  function cartHasSubscriptionItem(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    if (!SUB_VARIANT_ID) return false;
    var target = String(SUB_VARIANT_ID);
    try {
      return cart.items.some(function (item) {
        return String(item.variant_id) === target;
      });
    } catch (_e) {
      return false;
    }
  }

  function domHasSubscriptionLine() {
    return !!document.querySelector('[data-subscription-line="true"]');
  }

  function fetchCartData() {
    var now = Date.now();
    if (cartDataCache && now - cartDataTimestamp < CART_CACHE_WINDOW) {
      return Promise.resolve(cartDataCache);
    }
    if (cartFetchPromise) {
      return cartFetchPromise;
    }
    cartFetchPromise = fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function (data) {
        cartDataCache = data;
        cartDataTimestamp = Date.now();
        return data;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        cartFetchPromise = null;
      });
    return cartFetchPromise;
  }

  function computeCartTotals(cart) {
    var summary = { originalSubtotal: 0, discountedSubtotal: 0 };
    try {
      (cart.items || []).forEach(function (item) {
        if (String(item.variant_id) === String(SUB_VARIANT_ID)) return;
        var qty = typeof item.quantity === 'number' ? item.quantity : 1;
        var unitPrice = typeof item.price === 'number' ? item.price : 0;
        summary.originalSubtotal += unitPrice * qty;
        var discountedUnit = Math.floor(unitPrice * DISCOUNT_FACTOR);
        summary.discountedSubtotal += discountedUnit * qty;
      });
    } catch (_e) {}
    if (!summary.originalSubtotal && summary.discountedSubtotal) {
      summary.originalSubtotal = Math.round(summary.discountedSubtotal / DISCOUNT_FACTOR);
    }
    if (!summary.discountedSubtotal && summary.originalSubtotal) {
      summary.discountedSubtotal = Math.floor(summary.originalSubtotal * DISCOUNT_FACTOR);
    }
    return summary;
  }

  function applyCartTotals(summary) {
    var totalHtml =
      '<span class="member-total">' +
      formatMoney(summary.discountedSubtotal) +
      '</span> <s style="color: grey; font-size: 0.9em;">' +
      formatMoney(summary.originalSubtotal) +
      '</s>';
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      storeOriginal(el);
      el.innerHTML = totalHtml;
      el.classList.add('price-replaced');
    });

    var subtotalHtml =
      '<span class="member-subtotal">' +
      formatMoney(summary.discountedSubtotal) +
      '</span> <s style="color: grey; font-size: 0.9em;">' +
      formatMoney(summary.originalSubtotal) +
      '</s>';
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      storeOriginal(el);
      el.innerHTML = subtotalHtml;
      el.classList.add('price-replaced');
    });

    var savings = Math.max(summary.originalSubtotal - summary.discountedSubtotal, 0);
    document.querySelectorAll('[data-cart-savings]').forEach(function (el) {
      storeOriginal(el);
      el.textContent = formatMoney(savings);
      el.classList.add('price-replaced');
    });
  }

  function restoreCartTotals() {
    document.querySelectorAll('[data-cart-total], [data-cart-subtotal], [data-cart-savings]').forEach(function (el) {
      if (!el.classList.contains('price-replaced')) return;
      var originalHtml = el.getAttribute('data-orig-price-html');
      if (originalHtml !== null) {
        el.innerHTML = originalHtml;
      }
      var originalStyle = el.getAttribute('data-orig-price-style');
      if (originalStyle !== null) {
        if (originalStyle === '') {
          el.removeAttribute('style');
        } else {
          el.setAttribute('style', originalStyle);
        }
      }
      el.classList.remove('price-replaced');
      el.removeAttribute('data-orig-price-html');
      el.removeAttribute('data-orig-price-style');
      el.removeAttribute('data-orig-price-cents');
    });
  }

  function computeDomCartSummary() {
    var scopes = document.querySelectorAll('[data-line-unit-cents]');
    if (!scopes.length) return null;
    var seen = {};
    var summary = { originalSubtotal: 0, discountedSubtotal: 0 };
    scopes.forEach(function (scope) {
      if (!scope) return;
      if (scope.closest('[data-subscription-line="true"]')) return;
      var key = scope.getAttribute('data-line-key');
      if (key) {
        if (seen[key]) return;
        seen[key] = true;
      }
      var qty = parseInt(scope.getAttribute('data-line-qty') || '1', 10);
      if (!qty || qty < 1) qty = 1;
      var unit = parseInt(scope.getAttribute('data-line-unit-cents') || '0', 10);
      if (isNaN(unit) || unit < 0) {
        var finalLine = parseInt(scope.getAttribute('data-line-final-cents') || '0', 10);
        if (!isNaN(finalLine) && finalLine > 0) {
          unit = Math.round(finalLine / qty);
        } else {
          unit = 0;
        }
      }
      var originalLine = parseInt(scope.getAttribute('data-line-original-cents') || '0', 10);
      if (isNaN(originalLine) || originalLine <= 0) originalLine = unit * qty;
      summary.originalSubtotal += originalLine;
      summary.discountedSubtotal += Math.floor(unit * DISCOUNT_FACTOR) * qty;
    });
    if (!summary.originalSubtotal && !summary.discountedSubtotal) return null;
    return summary;
  }

  function updateCartTotals() {
    if (!shouldApplyReduction()) {
      restoreCartTotals();
      return;
    }
    if (domHasSubscriptionLine()) {
      restoreCartTotals();
      return;
    }
    var domSummary = computeDomCartSummary();
    if (domSummary) {
      applyCartTotals(domSummary);
      return;
    }
    fetchCartData()
      .then(function (cart) {
        if (!cart) {
          restoreCartTotals();
          return;
        }
        if (cartHasSubscriptionItem(cart)) {
          restoreCartTotals();
          return;
        }
        var summary = computeCartTotals(cart);
        if (!summary.originalSubtotal && !summary.discountedSubtotal) {
          restoreCartTotals();
          return;
        }
        applyCartTotals(summary);
      })
      .catch(function () {
        restoreCartTotals();
      });
  }

  function restoreOriginals() {
    document.querySelectorAll('.price-replaced').forEach(function (el) {
      var originalHtml = el.getAttribute('data-orig-price-html');
      if (originalHtml !== null) {
        el.innerHTML = originalHtml;
      }
      var originalStyle = el.getAttribute('data-orig-price-style');
      if (originalStyle !== null) {
        if (originalStyle === '') {
          el.removeAttribute('style');
        } else {
          el.setAttribute('style', originalStyle);
        }
      }
      el.removeAttribute('data-orig-price-html');
      el.removeAttribute('data-orig-price-style');
      el.removeAttribute('data-orig-price-cents');
      el.classList.remove('price-replaced');
    });
  }

  function shouldSkipElement(el) {
    if (!el) return true;
    var tagName = (el.tagName || '').toLowerCase();
    if (el.classList.contains('price-replaced') && tagName !== 'sale-price') return true;
    if (el.classList.contains('subscription-price')) return true;
    var priceList = el.closest && el.closest('price-list');
    if (priceList && priceList.querySelector('.subscription-price')) return true;
    return false;
  }

  function getLineScope(el) {
    if (!el || !el.closest) return null;
    var scope = el.closest('[data-line-unit-cents]');
    return scope || null;
  }

  function computeDiscountedCents(originalCents, el) {
    var scope = getLineScope(el);
    if (!scope) {
      return Math.floor(originalCents * DISCOUNT_FACTOR);
    }
    var qty = parseInt(scope.getAttribute('data-line-qty') || '1', 10);
    if (!qty || qty < 1) qty = 1;
    var unitCents = parseInt(scope.getAttribute('data-line-unit-cents') || '0', 10);
    if (isNaN(unitCents) || unitCents < 0) {
      var finalLine = parseInt(scope.getAttribute('data-line-final-cents') || '0', 10);
      if (!isNaN(finalLine) && finalLine > 0) {
        unitCents = Math.round(finalLine / qty);
      } else {
        unitCents = 0;
      }
    }
    var perUnitDiscounted = Math.floor(unitCents * DISCOUNT_FACTOR);
    return perUnitDiscounted * qty;
  }

  function applyToElement(el) {
    if (shouldSkipElement(el)) return;
    var cents = parsePriceCents(el);
    if (!cents && cents !== 0) return;
    var discountedCents = computeDiscountedCents(cents, el);
    if (discountedCents < 0) discountedCents = 0;

    storeOriginal(el);
    el.setAttribute('data-orig-price-cents', String(cents));

    var tagName = (el.tagName || '').toLowerCase();
    var formattedNew = formatMoney(discountedCents);
    var formattedOriginal = formatMoney(cents);

    if (tagName === 'sale-price') {
      el.innerHTML =
        '<span class="sr-only">Prix réduit</span>' +
        '<span class="price-item price-item--regular main-price" style="color: var(--text-primary); font-weight: 600;">' +
        formattedNew +
        '</span> <s style="color: grey; font-size: 0.9em;">' +
        formattedOriginal +
        '</s>';
      el.classList.add('price-replaced', 'text-on-sale');
      el.style.color = 'var(--text-primary)';
      return;
    }

    if (tagName === 'compare-at-price') {
      el.classList.add('price-replaced');
      return;
    }

    el.innerHTML =
      '<span class="price-item price-item--regular main-price" style="color: var(--text-primary); font-weight: 600;">' +
      formattedNew +
      '</span> <s style="color: grey; font-size: 0.9em;">' +
      formattedOriginal +
      '</s>';
    el.classList.add('price-replaced');
  }

  function updatePrices() {
    if (!shouldApplyReduction()) {
      restoreOriginals();
      return;
    }

    document.querySelectorAll(SELECTORS.join(',')).forEach(function (el) {
      applyToElement(el);
    });
  }

  function runReductionUpdate() {
    updatePrices();
    updateCartTotals();
    toggleSubscriptionUpsell();
  }

  setTimeout(runReductionUpdate, 100);

  var observer = new MutationObserver(function () {
    setTimeout(runReductionUpdate, 50);
  });
  try {
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (_e) {}

  document.addEventListener('variant:change', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    var formId = event && event.target ? event.target.id : null;

    document.querySelectorAll('sale-price').forEach(function (el) {
      if (formId && el.getAttribute('form') && el.getAttribute('form') !== formId) return;
      el.classList.remove('price-replaced');
      el.removeAttribute('data-orig-price-html');
      el.removeAttribute('data-orig-price-style');
      el.removeAttribute('data-orig-price-cents');
      if (variant && typeof variant.price === 'number') {
        el.setAttribute('data-orig-price-cents', String(variant.price));
      }
    });

    document.querySelectorAll('compare-at-price').forEach(function (el) {
      if (formId && el.getAttribute('form') && el.getAttribute('form') !== formId) return;
      el.classList.remove('price-replaced');
      el.removeAttribute('data-orig-price-html');
      el.removeAttribute('data-orig-price-style');
      el.removeAttribute('data-orig-price-cents');
    });

    setTimeout(runReductionUpdate, 50);
  });

  ['cart:refresh', 'cart:rerendered', 'cart:updated'].forEach(function (evtName) {
    document.addEventListener(evtName, function () {
      setTimeout(runReductionUpdate, 50);
    });
  });
});
